import { formattedDate } from '@helper/util/formattedDate'

import {
  IModifyParamsToSend,
  IParamsToSend
} from '@base/@types/providers/Alert/FollowUpProvider'

export const paramsAlertToSendMapping = ({
  name,
  value,
  compareName,
  fieldName,
  paramsToSend
}: IModifyParamsToSend) => {
  const paramsToSendFormatted: IParamsToSend = { ...paramsToSend }

  if (
    name === 'purchaseOrderTypesSelectIds' ||
    name === 'purchaseOrderTypesIds'
  ) {
    paramsToSendFormatted.tipoPedido = {
      agrupar:
        name === 'purchaseOrderTypesIds'
          ? typeof value === 'boolean'
            ? value
            : paramsToSendFormatted.tipoPedido.agrupar
          : paramsToSendFormatted.tipoPedido.agrupar,
      descricoes:
        name === 'purchaseOrderTypesSelectIds'
          ? typeof value === 'object'
            ? value.map(item => item.value)
            : paramsToSend.tipoPedido.ids
          : paramsToSendFormatted.tipoPedido.descricoes
    }
    return paramsToSendFormatted
  }
  if (name === 'tipoCentroIds' || name === 'tipoCentroSelectIds') {
    paramsToSendFormatted.tipoCentro = {
      agrupar:
        name === 'tipoCentroIds'
          ? typeof value === 'boolean'
            ? value
            : paramsToSendFormatted.tipoCentro.agrupar
          : paramsToSendFormatted.tipoCentro.agrupar,
      descricoes:
        name === 'tipoCentroSelectIds'
          ? typeof value === 'object'
            ? value.map(item => item.value)
            : paramsToSend.tipoCentro.ids
          : paramsToSendFormatted.tipoCentro.descricoes
    }
    return paramsToSendFormatted
  }
  if (name === 'pedidosSelectIds') {
    paramsToSendFormatted.pedidos = {
      agrupar: false,
      descricoes:
        name === 'pedidosSelectIds'
          ? typeof value === 'object'
            ? value.map(item => item.value)
            : paramsToSend.pedidos.ids
          : paramsToSendFormatted.pedidos.descricoes
    }
    return paramsToSendFormatted
  }
  if (
    name === 'initialDate' ||
    name === 'finalDate' ||
    name === 'periodoIds' ||
    name === 'periodoSelectIds'
  ) {
    paramsToSendFormatted.periodo = {
      inicio:
        name === 'initialDate'
          ? formattedDate(String(value))
          : paramsToSendFormatted.periodo.inicio,
      final:
        name === 'finalDate'
          ? formattedDate(String(value))
          : paramsToSendFormatted.periodo.final,
      agrupar:
        name === 'periodoIds' ? value : paramsToSendFormatted.periodo.agrupar
    }

    return paramsToSendFormatted
  }

  if (name === compareName) {
    paramsToSendFormatted[fieldName] = {
      agrupar:
        typeof value === 'boolean'
          ? value
          : paramsToSendFormatted[fieldName].agrupar,
      ids:
        typeof value === 'object'
          ? value.map(item => item.value)
          : paramsToSend[fieldName].ids
    }
  }

  return paramsToSendFormatted
}
